export const TW = 1;
export const IG = 2;
export const FB = 3;
export const YT = 4;
export const BROADCAST = 5;
export const IN_VENUE = 26;
